import { useStore, useTasksStore } from '@assets/model/Store';
import { observer } from 'mobx-react';
import { useEffect, useRef } from 'react';
import { Slide, toast } from 'react-toastify';

export const ActiveJob = observer(() => {
    const activeJobToaster = useRef(null);
    const store = useStore();
    useEffect(() => {
        if (store.activeJob && store.activeJob.status == 'processing') {
            if (activeJobToaster.current == null) {
                activeJobToaster.current = toast.info(
                    `Analysis \r\n ${store.activeJob.task}`,
                    {
                        progress: 0,
                        autoClose: false,
                        closeButton: false
                    }
                );
            }

            const progress = Math.min(store.activeJob.progress || 0, 0.99);

            toast.update(activeJobToaster.current, {
                render: (
                    <span style={{ marginLeft: 'auto' }}>
                        {store.activeJob.task}{' '}
                        <b>{(progress * 100).toFixed(0)}%</b>
                    </span>
                ),
                progress
            });
        } else {
            if (activeJobToaster.current) {
                toast.dismiss(activeJobToaster.current);
                activeJobToaster.current = null;
            }
        }
    }, [store.activeJob]);

    useEffect(() => {
        if (!store.taskActiveJob) return;
        if (store.taskActiveJob.status != 'in_progress') return;

        if (activeJobToaster.current) {
            toast.dismiss(activeJobToaster.current);
            activeJobToaster.current = null;
        }

        const taskDef = useTasksStore().get_task_definition(
            store.taskActiveJob.taskId
        );
        activeJobToaster.current = toast.info(`${taskDef.name} Started`, {
            progress: 0,
            autoClose: 5000,
            closeButton: true,
            transition: Slide
        });
    }, [store.taskActiveJob]);
    return null;
});
